<template>
  <component
    :is="tag"
    :class="['message-type', `message-type-${type}`, 'rounded', { 'message-type-multiple': multiple }]"
    v-on="button ? { click: () => $emit('click', type) } : {}"
  >
    {{ text[type] }}
  </component>
</template>

<script>
import { CATEGORY_TYPE } from '@/helpers/types'

export default {
  name: 'MessageType',

  props: {
    type: {
      type: String,
      default: ''
    },

    button: {
      type: Boolean,
      default: false
    },

    multiple: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tag() {
      return this.button ? 'button' : 'div'
    }
  },

  data() {
    return {
      text: {
        [CATEGORY_TYPE.WELCOME]: 'Welcome',
        [CATEGORY_TYPE.THANKYOU]: 'Thank You',
        [CATEGORY_TYPE.KUDO]: 'Kudo',
        [CATEGORY_TYPE.COACHING]: 'Coaching',
        [CATEGORY_TYPE.FEEDBACK]: 'Feedback'
      }
    }
  }
}
</script>
